// ============ السكرول الناعم (Lenis) ============
// App.js بيسجّل نسخة Lenis هنا، وأي زرار (العودة للأعلى، روابط الأقسام) بيستخدمها عشان الحركة تبقى ناعمة.
let lenis = null;

export const setLenis = (instance) => {
  lenis = instance;
};
export const getLenis = () => lenis;

// إعدادات السكرول: lerp أقل = أنعم وأهدى (0.07–0.1 مناسب)
export const LENIS_OPTIONS = {
  lerp: 0.085,
  smoothWheel: true,
  wheelMultiplier: 0.95,
  touchMultiplier: 1.4,
  anchors: true,
};

const EASE_OUT = (t) => 1 - Math.pow(1 - t, 4);

export const scrollToTop = () => {
  if (lenis) lenis.scrollTo(0, { duration: 1.6, easing: EASE_OUT });
  else window.scrollTo({ top: 0, behavior: "smooth" });
};

export const scrollToEl = (el, offset = 0) => {
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { duration: 1.4, offset, easing: EASE_OUT });
  else el.scrollIntoView({ behavior: "smooth", block: "start" });
};
